import {useRef} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import useDidUpdateEffect from '../../../hooks/useDidUpdateEffect';
import {focusLeftMainContent} from '../../../v2/actions/accessibilityActions';

export function MainContentWrapperPresentational(props) {
  const mainContent = useRef(null);
  
  useDidUpdateEffect(() => {
    mainContent.current.focus();
  }, [props.mainContentFocused]);
  
  const handleBlur = () => {
    props.focusLeftMainContent();
  };
  
  return (
    <main
      role="main"
      id="main-content"
      ref={mainContent}
      tabIndex={props.mainContentFocused ? -1 : undefined}
      onBlur={handleBlur}
    >
      {props.children}
    </main>
  );
}

const mapStateToProps = state => ({mainContentFocused: state.accessibility.mainContentFocused});

MainContentWrapperPresentational.propTypes = {
  children: PropTypes.node.isRequired,
  mainContentFocused: PropTypes.bool.isRequired,
  focusLeftMainContent: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  {focusLeftMainContent},
)(MainContentWrapperPresentational);
